import { Link } from "react-router-dom";
import { studentIdsForAccount } from "../domain/auth";
import { eventAudienceLabel, eventDescription, studentsOpenForEvent } from "../domain/data";
import { useAuth } from "../state/AuthProvider";
import { useEvents } from "../state/events";
import { useLocale } from "../state/i18n";
import { useStudents } from "../state/students";
import { PrototypeBanner, PublicNav } from "../components/ui";

export function PublicEvents() {
  const { account, session } = useAuth();
  const { studentsByIds } = useStudents();
  const { upcomingEvents, countsFor } = useEvents();
  const { locale, t } = useLocale();
  const ids = account ? studentIdsForAccount(account) : [];
  const household = studentsByIds(ids);
  const listed =
    ids.length > 0 && household.length === 0
      ? []
      : household.length > 0
        ? upcomingEvents.filter((event) => studentsOpenForEvent(event, household).length > 0)
        : upcomingEvents;

  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <PublicNav />
        <p className="meta">{t("events.publicMeta")}</p>
        <h1>{t("events.publicTitle")}</h1>
        <p className="lede">
          {t(session ? "events.publicLedeSignedIn" : "events.publicLede")}
        </p>

        {listed.length === 0 ? (
          <div className="wire dashed">
            <div className="meta">
              {household.length > 0 && upcomingEvents.length > 0
                ? t("events.noneForStudents")
                : t("events.none")}
            </div>
          </div>
        ) : (
          <ul className="list-plain">
            {listed.map((event) => {
              const counts = countsFor(event.id);
              const availability =
                counts.remaining > 0
                  ? t("events.spots", { count: counts.remaining })
                  : event.waitlistEnabled
                    ? t("events.waitlistOpen")
                    : t("events.full");
              const description = eventDescription(event, locale);
              return (
                <li key={event.id}>
                  <Link to={`/events/${event.id}`}>
                    <div className="row">
                      <div>
                        <div className="title">
                          <strong>{event.name}</strong>
                        </div>
                        <div className="anno">
                          {event.dateLabel} · {event.timeLabel} · {event.location}
                        </div>
                        <div className="anno">{eventAudienceLabel(event)}</div>
                        {description ? (
                          <div className="anno">{description}</div>
                        ) : null}
                      </div>
                      <div className="tag muted">
                        {availability}
                      </div>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </main>
    </div>
  );
}
